'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.

var EventEmitter = require('eventemitter3');var

PromiseProvider = function (_EventEmitter) {_inherits(PromiseProvider, _EventEmitter);
  function PromiseProvider(provider) {_classCallCheck(this, PromiseProvider);var _this = _possibleConstructorReturn(this, (PromiseProvider.__proto__ || Object.getPrototypeOf(PromiseProvider)).call(this));


    _this.provider = provider;
    _this.provider.on('connected', function () {return _this.emit('connected');});
    _this.provider.on('connecting', function () {return _this.emit('connecting');});
    _this.provider.on('disconnected', function () {return _this.emit('disconnected');});

    _this.send = _this.send.bind(_this);return _this;
  }_createClass(PromiseProvider, [{ key: 'send', value: function send(









    method) {var _this2 = this;for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {params[_key - 1] = arguments[_key];}
      if (!this.provider.send) {
        // old-style transport interface for backwards compatibility
        return this.provider.execute(method, params);
      }

      return new Promise(function (resolve, reject) {
        _this2.provider.send(method, params, function (error, result) {
          if (error) {
            reject(error);
          } else {
            resolve(result);
          }
        });
      });
    } }, { key: 'isConnected', get: function get() {return this.provider.isConnected;} }, { key: 'isParity', get: function get() {return !!this.provider.isParity;} }]);return PromiseProvider;}(EventEmitter);


module.exports = PromiseProvider;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/api/lib/provider/promise.js
// module id = 447
// module chunks = 0